import { render } from "./ProgramasArea.vue?vue&type=template&id=4cce57a8"
import script from "./ProgramasArea.vue?vue&type=script&lang=js"
export * from "./ProgramasArea.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__